import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import moment from 'moment';

const ContactDetailsModal = ({ item }) => {
  return (
    <>
      <ModalHeader className="bg-primary text-white">
        Contact Message Details
      </ModalHeader>
      <ModalBody>
        {item ? (
          <div className="p-4 border rounded">
            <div className="mb-4">
              <h5 className="text-primary mb-3">Sender Information</h5>
              <div className="d-flex align-items-center mb-2">
                <i className="bi bi-person me-2"></i>
                <strong>Name:&nbsp;</strong>
                {item.name}
              </div>
              <div className="d-flex align-items-center mb-2">
                <i className="bi bi-envelope me-2"></i>
                <strong>Email:&nbsp;</strong>
                {item.email}
              </div>
              <div className="d-flex align-items-center mb-2">
                <i className="bi bi-clock me-2"></i>
                <strong>Date:&nbsp;</strong>
                {moment(item.date).format("DD-MM-YYYY HH:mm")}
              </div>
            </div>
            <div className="mb-3">
              <h5 className="text-primary mb-3">Message Content</h5>
              <div className="p-3 bg-light rounded">
                <p className="mb-0">{item.description}</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center p-4">
            <h5 className="text-muted">No data found</h5>
          </div>
        )}
      </ModalBody>
    </>
  );
};

export default ContactDetailsModal; 